/**
 * API back-office : demandes d'inscription parents (validation par code dicté).
 */
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHeaders } from './baseApi';

export interface DemandeInscription {
  id: number;
  telephone: string;
  email: string;
  nom: string;
  prenoms: string;
  matricule_etudiant: string;
  nom_etudiant: string;
  prenoms_etudiant: string;
  classe_etudiant: string;
  date_naissance_etudiant: string;
  relation: string;
  statut: 'en_attente' | 'code_envoye' | 'valide' | 'rejete';
  code_validation: string;
  code_expire_le: string | null;
  date_demande: string;
  date_traitement: string | null;
  traite_par_nom: string;
  motif_rejet: string;
  auto_validee: boolean;
  ip_demande: string | null;
}

export const inscriptionsParentsApi = createApi({
  reducerPath: 'inscriptionsParentsApi',
  baseQuery: baseQueryWithHeaders,
  tagTypes: ['Inscriptions'],
  endpoints: (builder) => ({
    getInscriptions: builder.query<{
      results: DemandeInscription[];
      nb_en_attente: number;
      nb_code_envoye: number;
    }, { statut?: string } | void>({
      query: (params) => ({
        url: '/portail-parent/admin/inscriptions/',
        params: params ?? undefined,
      }),
      providesTags: ['Inscriptions'],
    }),

    genererCodeInscription: builder.mutation<{
      success: boolean; code: string; expire_le: string;
      demande: DemandeInscription;
    }, number>({
      query: (id) => ({
        url: `/portail-parent/admin/inscriptions/${id}/generer-code/`,
        method: 'POST',
      }),
      invalidatesTags: ['Inscriptions'],
    }),

    rejeterInscription: builder.mutation<{ success: boolean }, { id: number; motif: string }>({
      query: ({ id, motif }) => ({
        url: `/portail-parent/admin/inscriptions/${id}/rejeter/`,
        method: 'POST',
        body: { motif },
      }),
      invalidatesTags: ['Inscriptions'],
    }),
  }),
});

export const {
  useGetInscriptionsQuery,
  useGenererCodeInscriptionMutation,
  useRejeterInscriptionMutation,
} = inscriptionsParentsApi;
